<i18n>
[
    "reviews__fit--label",
    "reviews__fit--label-text",
]
</i18n>

<template>
    <div v-if="reviewSummary.fitRatingCount">
        <div class="u-spacer--1pt5 o-text--caption">
            {{ t('reviews__fit--label') }}
            <span
                class="u-text--gray"
                :class="{ 'o-text--caption': smallText }"
            >
                {{ t('reviews__fit--label-text', reviewSummary.fitRatingCount) }}
            </span>
        </div>
        <BarGraph
            :ratingAverage="reviewSummary.fitRatingAverage"
            :barType="BAR_GRAPH_FIT"
            :smallBarGraph="smallText"
        />
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import { BAR_GRAPH_FIT } from '~modules/core/js/bar-graph-constants';

import BarGraph from '~modules/core/components/ui/BarGraph.vue';

defineProps({
    reviewSummary: {
        type: Object,
        required: true,
    },
    smallText: {
        type: Boolean,
        default: false,
    },
});

const { t } = useI18n();
</script>

<style lang="scss">

</style>
